import $ from 'jquery';

const getHeight = ($elem) => {
    return $elem.outerHeight(false);
};

export const setHeight = ($elems) => {
    let height = 0;
    $elems.removeAttr('style');
    $elems.each((index, elem) => {
        const $elem = $(elem);
        const h = getHeight($elem);

        height = h > height ? h : height;
    });

    $elems.outerHeight(height);
};
